import { post } from "@util/api"
import { isDefined, isNonEmptyString, reduceErrors, validate, ValidationErrors } from "@util/validations"

export interface Adjustment {
  id?: number
  nonRefundable: boolean
  transactionType?: "credit" | "debit" | "non_refundable_debit"
  participationId?: number
  forConvenienceFees?: boolean
  coveredByInsurance?: boolean
  description: string
  price?: number
}

export function newAdjustment(): Adjustment {
  return { price: undefined, description: "", nonRefundable: false }
}

export function validateAdjustment(data: Adjustment): ValidationErrors<Adjustment> {
  return reduceErrors({
    description: [validate(isNonEmptyString(data.description), "You must enter a description for this adjustment")],
    participationId: [validate(isDefined(data.participationId), "You must select a passenger to apply the adjustment to")],
    transactionType: [validate(isDefined(data.transactionType), "You must select a type of adjustment")],
    coveredByInsurance: [
      validate(isDefined(data.coveredByInsurance), "You must choose whether this is covered by travel protection"),
    ],
    price: [
      validate(isDefined(data.price), "You must enter an adjustment amount"),
      validate(data.price !== 0, "The adjustment amount must not be 0"),
    ],
  })
}

export function totalForCoveredAdjustments(adjustments: Adjustment[]): number {
  return adjustments.filter((a) => a.id !== undefined && a.coveredByInsurance).reduce((acc, a) => acc + a.price, 0)
}

export async function adjustedBalance(
  adjustment: Adjustment,
  insuranceDiffPath: string,
  userId: number,
  initialBalance?: number,
) {
  let insuranceDiff = 0

  if (adjustment.coveredByInsurance) {
    let result = await post(insuranceDiffPath, { adjustment, userId })
    insuranceDiff = result.body.data.insuranceDiff
  }

  if (adjustment.transactionType === "credit") {
    return initialBalance - (adjustment.price || 0) + insuranceDiff
  } else if (adjustment.transactionType === "debit") {
    return initialBalance + (adjustment.price || 0) + insuranceDiff
  } else if (adjustment.transactionType === undefined) {
    return null
  }
}
